import React, { Component } from "react";
import Subjektif from "../form/Subjektif.js";
import Assesment from "../form/Assesment";
import Planning from "../form/Planning.js";
import KbObjective from "./KbUlangObjective";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

export default class Kb extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visitId: 1000,
      modules: [
        { id: "1", name: "Subjektif" },
        { id: "2", name: "Objektif" },
        { id: "3", name: "Assesment" },
        { id: "4", name: "Planning" },
      ],
      visible: false,
      detilPx: this.props.detilPx,
      tabIndex: 0,
    };
    this.nextTab = this.nextTab.bind(this);
    this.parentCallback = this.parentCallback.bind(this);

  }
  parentCallback(data) {
    this.setState((prevState) => ({
      detilPx: {
        // object that we want to update
        ...prevState.detilPx, // keep all other key-value pairs
        [data.param]: data.data,
      },
    }));
    // console.log(data);
  }

  nextTab() {
    const tabs = this.state.tabIndex;
    const tabIndex = tabs + 1;
    this.setState({ tabIndex: tabIndex });
  }

  render() {
    var patient = this.state.detilPx;
    return (
      <div>
        <div className="card">
          <div className="card-header">
            <div className="row align-items-center">
              <div className="col-8">
                <h4 className="h3 mb-0">Form Pemeriksaan KB Ulang</h4>
              </div>
            </div>
          </div>
          <div className="card-body">
            <Tabs
              selectedIndex={this.state.tabIndex}
              onSelect={(tabIndex) => this.setState({ tabIndex })}
            >
              <TabList>
                <Tab id="Subjektif">Subjektif </Tab>
                <Tab id="Objektif">Objektif </Tab>
                <Tab id="Assesment">Assesment </Tab>
                <Tab id="Planning">Planning </Tab>
              </TabList>
              <TabPanel tabId="Subjektif">
                <Subjektif
                  patient={patient}
                  parentCallback={this.parentCallback}
                  history={this.props.history}
                  nextTab={this.nextTab}
                />
              </TabPanel>
              <TabPanel tabId="Objektif">
                {/* <Objektif
                      patient={patient}
                      parentCallback={this.parentCallback}
                      history={this.props.history}
                      nextTab={this.nextTab}
                    /> */}
                <KbObjective
                  patient={patient}
                  parentCallback={this.parentCallback}
                  history={this.props.history}
                  nextTab={this.nextTab}
                />
              </TabPanel>
              <TabPanel tabId="Assesment">
                <Assesment
                  patient={patient}
                  parentCallback={this.parentCallback}
                  history={this.props.history}
                  nextTab={this.nextTab}
                />
              </TabPanel>
              <TabPanel tabId="Planning">
                <Planning
                  patient={patient}
                  parentCallback={this.parentCallback}
                  history={this.props.history}
                  nextTab={this.nextTab}
                />
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
    );
  }
}
